export default "__VITE_ASSET__BWDJxZkh__"